import { companyProfileService } from '../../services/companyProfile.service'

const FALLBACK_PROFILE = {
  id: null,
  name: 'Travel and Cargo',
  address: '263 Calder Street, Glasgow, G42 7QG',
  telephone: '0141 422 20 21/ 0141 422 20 23',
  website: 'www.travcargo.co.uk',
  email: 'info@travcargo.co.uk',
  logo: 'invoice_logo.png',
  isDefault: true
}

const state = {
  profiles: [],
  selectedProfileForPrint: null,
  loading: false
}

const getters = {
  defaultProfile (state) {
    const def = state.profiles.find(p => p.isDefault)
    return def || FALLBACK_PROFILE
  },
  activeProfile (state, getters) {
    return state.selectedProfileForPrint || getters.defaultProfile
  }
}

const mutations = {
  setProfiles (state, profiles) {
    state.profiles = profiles
  },
  setSelectedProfileForPrint (state, profile) {
    state.selectedProfileForPrint = profile
  },
  setLoading (state, val) {
    state.loading = val
  }
}

const actions = {
  fetchProfiles ({ commit }) {
    commit('setLoading', true)
    return companyProfileService.getAllProfiles().then(profiles => {
      commit('setProfiles', profiles)
      commit('setLoading', false)
    }).catch(() => {
      commit('setLoading', false)
    })
  },
  createProfile ({ dispatch }, profileData) {
    return companyProfileService.createProfile(profileData).then(() => {
      return dispatch('fetchProfiles')
    })
  },
  updateProfile ({ dispatch }, profileData) {
    return companyProfileService.updateProfile(profileData).then(() => {
      return dispatch('fetchProfiles')
    })
  },
  deleteProfile ({ dispatch }, id) {
    return companyProfileService.deleteProfile(id).then(() => {
      return dispatch('fetchProfiles')
    })
  },
  setDefault ({ dispatch }, id) {
    return companyProfileService.setDefaultProfile(id).then(() => {
      return dispatch('fetchProfiles')
    })
  },
  selectProfileForPrint ({ commit }, profile) {
    commit('setSelectedProfileForPrint', profile)
  }
}

export const companyProfiles = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
